export default {"src":"/_next/static/media/GEHC.ba14d06f.svg","height":18,"width":18};